import React from "react";
import { withStyles, withTheme, Grid } from "@material-ui/core";
import { compose } from "recompose";
import {
  FormatMinutesIntoTimeString,
  getTimeDifferenceInMinutes,
} from "../NextStopComplianceUtills";

const styles = (theme) => ({
  kpiHeader: {
    fontWeight: "bold",
    fontSize: "18px",
    lineHeight: "21px",
    color: theme.iconColor,
    display: "flex",
    alignItems: "center",
    justifyItems: "center",
  },
  kpiText: {
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    paddingBottom: "5px",
    fontWeight: 400,
  },
  kpi: {
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
  },
  kpiBox: {
    display: "block",
    alignItems: "center",
    textAlign: "center",
    padding: "15px 0px",
  },
  kpiSmallBox: {
    display: "block",
    alignItems: "center",
    textAlign: "center",
    padding: "15px 0px",
  },
  kpiRedText: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.deviationStopPopupColor,
    paddingBottom: "5px",
  },
  kpiTextBold: {
    fontWeight: "bold",
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.iconColor,
    paddingBottom: "5px",
  },
});

const StopKPI = ({ classes, stopDetails, routeData }) => {
  return (
    <React.Fragment>
      <Grid container>
        <Grid container>
          <Grid item xs={2} className={classes.kpiHeader}>
            KPI
          </Grid>
          <Grid container item xs={10}>
            <Grid container>
              <Grid item xs={4} className={classes.kpiBox}>
                <div>
                  <span className={classes.kpiTextBold}>
                    {stopDetails.milesAdded}
                  </span>
                </div>
                <div className={classes.kpi}>Miles Added at this Stop</div>
              </Grid>

              <Grid item xs={4} className={classes.kpiSmallBox}>
                <div>
                  <span className={classes.kpiTextBold}>
                    {`${stopDetails.totalStops} / `}
                  </span>
                  <span className={classes.kpiText}>
                    {routeData.totalStops}
                  </span>
                </div>
                <div className={classes.kpi}>Total Stops</div>
              </Grid>
              <Grid item xs={4} className={classes.kpiBox}>
                <div>
                  <span className={classes.kpiTextBold}>
                    {`${getTimeDifferenceInMinutes(
                      stopDetails.plannedDepartureTime,
                      stopDetails.plannedArrivalTime
                    )} / `}
                  </span>
                  <span className={classes.kpiText}>
                    {getTimeDifferenceInMinutes(
                      stopDetails.actualDepartureTime,
                      stopDetails.actualArrivalTime
                    )}
                  </span>
                </div>
                <div className={classes.kpi}>Planned / Actual Stop Time</div>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={3} className={classes.kpiSmallBox}>
                <div>
                  <span className={classes.kpiTextBold}>
                    {`${stopDetails.totalBills} / `}
                  </span>
                  <span className={classes.kpiText}>
                    {routeData.totalBills}
                  </span>
                </div>
                <div className={classes.kpi}>Total Bills</div>
              </Grid>
              <Grid item xs={3} className={classes.kpiSmallBox}>
                <div>
                  <span className={classes.kpiTextBold}>
                    {`${stopDetails.totalMiles} / `}
                  </span>
                  <span className={classes.kpiText}>
                    {routeData.totalMiles}
                  </span>
                </div>
                <div className={classes.kpi}>Total Miles</div>
              </Grid>
              <Grid item xs={4} className={classes.kpiSmallBox}>
                <div>
                  <span className={classes.kpiTextBold}>
                    {`${FormatMinutesIntoTimeString(stopDetails.totalTime)} / `}
                  </span>
                  <span className={classes.kpiText}>
                    {FormatMinutesIntoTimeString(routeData.totalTime)}
                  </span>
                </div>
                <div className={classes.kpi}>Total Time</div>
              </Grid>
              <Grid item xs={2} className={classes.kpiSmallBox}>
                <div>
                  <span
                    className={
                      stopDetails.missedApts > 0
                        ? classes.kpiRedText
                        : classes.kpiTextBold
                    }
                  >
                    {`${stopDetails.missedApts} / `}
                  </span>
                  <span
                    className={
                      routeData.missedApts > 0
                        ? classes.kpiRedText
                        : classes.kpiTextBold
                    }
                  >
                    {routeData.missedApts}
                  </span>
                </div>
                <div className={classes.kpi}>Missed Appt.</div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default compose(withStyles(styles), withTheme())(StopKPI);
